var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.42592 24.0852C6.42592 24.0852 6.34037 24.0852 6.29149 24.0608C6.16928 24.0119 6.09595 23.8897 6.09595 23.7675V19.4413H1.43981C1.26872 19.4413 1.12207 19.2947 1.12207 19.1236V3.62756C1.12207 3.45646 1.26872 3.30981 1.43981 3.30981H21.5309C21.702 3.30981 21.8486 3.45646 21.8486 3.62756V19.1236C21.8486 19.2947 21.702 19.4413 21.5309 19.4413H11.6076L6.63367 23.9997C6.63367 23.9997 6.49924 24.0852 6.41369 24.0852H6.42592ZM1.75755 18.8058H6.41369C6.58479 18.8058 6.73144 18.9525 6.73144 19.1236V23.0343L11.2654 18.8792C11.2654 18.8792 11.3998 18.7936 11.4853 18.7936H21.2131V3.9453H1.75755V18.7936V18.8058Z",
    fill: "currentColor",
    stroke: "#004137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.3541 17.7915H21.5311C21.36 17.7915 21.2134 17.6449 21.2134 17.4738C21.2134 17.3027 21.36 17.1561 21.5311 17.1561H24.0242V1.7578H4.5808V3.62759C4.5808 3.79868 4.43415 3.94533 4.26305 3.94533C4.09196 3.94533 3.94531 3.79868 3.94531 3.62759V1.44006C3.94531 1.26896 4.09196 1.12231 4.26305 1.12231H24.3541C24.5252 1.12231 24.6719 1.26896 24.6719 1.44006V17.4738C24.6719 17.6449 24.5252 17.7915 24.3541 17.7915Z",
    fill: "currentColor",
    stroke: "#004137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.38 22.4353C19.3067 22.4353 19.2211 22.4108 19.16 22.3497L15.8971 19.3556C15.7626 19.2334 15.7626 19.0379 15.8726 18.9034C15.9948 18.769 16.1904 18.769 16.3248 18.879L19.0501 21.3721V19.1112C19.0501 18.9401 19.1967 18.7935 19.3678 18.7935C19.5389 18.7935 19.6855 18.9401 19.6855 19.1112V22.1053C19.6855 22.2275 19.6122 22.3497 19.49 22.3986C19.4533 22.4108 19.4045 22.423 19.3556 22.423L19.38 22.4353Z",
    fill: "currentColor",
    stroke: "#004137",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.5737 8.28392H4.26305C4.09196 8.28392 3.94531 8.13727 3.94531 7.96618C3.94531 7.79509 4.09196 7.64844 4.26305 7.64844H18.5737C18.7448 7.64844 18.8914 7.79509 18.8914 7.96618C18.8914 8.13727 18.7448 8.28392 18.5737 8.28392Z",
    fill: "currentColor",
    stroke: "#004137",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.5738 8.40602H4.26319C4.01878 8.40602 3.82324 8.21049 3.82324 7.96607C3.82324 7.72166 4.01878 7.52612 4.26319 7.52612H18.5738C18.8182 7.52612 19.0137 7.72166 19.0137 7.96607C19.0137 8.21049 18.8182 8.40602 18.5738 8.40602ZM4.26319 7.77054C4.15321 7.77054 4.06766 7.85609 4.06766 7.96607C4.06766 8.07606 4.15321 8.16161 4.26319 8.16161H18.5738C18.6838 8.16161 18.7693 8.07606 18.7693 7.96607C18.7693 7.85609 18.6838 7.77054 18.5738 7.77054H4.26319Z",
    fill: "currentColor",
    stroke: "#004137",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.5737 10.9055H4.26305C4.24984 10.9055 4.23241 10.8996 4.2168 10.884C4.20119 10.8684 4.19531 10.851 4.19531 10.8378C4.19531 10.8245 4.20119 10.8071 4.2168 10.7915C4.23241 10.7759 4.24984 10.77 4.26305 10.77H18.5737C18.5869 10.77 18.6043 10.7759 18.6199 10.7915C18.6355 10.8071 18.6414 10.8245 18.6414 10.8378C18.6414 10.851 18.6355 10.8684 18.6199 10.884C18.6043 10.8996 18.5869 10.9055 18.5737 10.9055Z",
    fill: "currentColor",
    stroke: "#004137",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.5738 11.2776H4.26319C4.01878 11.2776 3.82324 11.0821 3.82324 10.8377C3.82324 10.5932 4.01878 10.3977 4.26319 10.3977H18.5738C18.8182 10.3977 19.0137 10.5932 19.0137 10.8377C19.0137 11.0821 18.8182 11.2776 18.5738 11.2776ZM4.26319 10.6299C4.15321 10.6299 4.06766 10.7154 4.06766 10.8254C4.06766 10.9354 4.15321 11.021 4.26319 11.021H18.5738C18.6838 11.021 18.7693 10.9354 18.7693 10.8254C18.7693 10.7154 18.6838 10.6299 18.5738 10.6299H4.26319Z",
    fill: "currentColor",
    stroke: "#004137",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.98241 14.0156H4.26305C4.09196 14.0156 3.94531 13.869 3.94531 13.6979C3.94531 13.5268 4.09196 13.3801 4.26305 13.3801H9.98241C10.1535 13.3801 10.3001 13.5268 10.3001 13.6979C10.3001 13.869 10.1535 14.0156 9.98241 14.0156Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.98255 14.1377H4.26319C4.01878 14.1377 3.82324 13.9422 3.82324 13.6978C3.82324 13.4533 4.01878 13.2578 4.26319 13.2578H9.98255C10.227 13.2578 10.4225 13.4533 10.4225 13.6978C10.4225 13.9422 10.227 14.1377 9.98255 14.1377ZM4.26319 13.5022C4.15321 13.5022 4.06766 13.5878 4.06766 13.6978C4.06766 13.8078 4.15321 13.8933 4.26319 13.8933H9.98255C10.0925 13.8933 10.1781 13.8078 10.1781 13.6978C10.1781 13.5878 10.0925 13.5022 9.98255 13.5022H4.26319Z",
    fill: "currentColor",
    stroke: "#004137",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportNew);
export default __webpack_public_path__ + "static/media/Support_new.f63e8f380eed7bd96004f26cebd910bd.svg";
export { ForwardRef as ReactComponent };